import { FC } from "react";
import VariantItem from "~/components/Items/VariantItem";
import styles from "./SwatchSelect.module.scss";
import classNames from "classnames";
import Image from "next/image";
import { ProductVariant } from "~/services/product";
import { useRecoilValue, useSetRecoilState } from "recoil";
import productAtom from "~/services/product/product.atom";

type Options = {
  label: string;
  value_index: number;
  url?: string;
  disabled?: boolean;
  swatchObject?: ProductVariant;

}
interface SwatchSelectProps {
  title?: string;
  options?: Options[];
  value?: number;
  onChange?: (value: Options) => void;
}

const SwatchSelect: FC<SwatchSelectProps> = ({
  title,
  options,
  value,
  onChange,
}) => {
  const setProduct =  useSetRecoilState(productAtom.Product)
  const {hoverSwatchOptions } =  useRecoilValue(productAtom.Product)
  const optionsSelected = options?.find((op) => op.value_index === value);
  const handleOnOver =  (option:Options) => {
    if(optionsSelected?.value_index === option.value_index) return
    setProduct((prev) => ({...prev, hoverSwatchOptions:{
      label:option?.label,
      thumbnail:option?.swatchObject?.product?.thumbnail?.url || ''
    }}))
  }
  return (
    <VariantItem title={title} value={hoverSwatchOptions?.label || optionsSelected?.label}>
      <div className={classNames("flex gap-3 flex-wrap", styles.single_select)} 
       >
        {options?.map((op) => (
          <div
          onMouseOver={() => handleOnOver(op)}
          onMouseOut={() => setProduct((prev) => ({...prev, hoverSwatchOptions:undefined}))}
            key={op.value_index}
            className={classNames(styles.select_item, {
              [styles.selected]: op.value_index === value,
              [styles.disabled]: op.disabled,
            })}
            onClick={op.disabled ? undefined : () => onChange?.(op)}
          >
            <img
              src={op?.swatchObject?.product?.thumbnail?.url ?? ""}
              alt={op.label}
             />
          </div>
        ))}
      </div>
    </VariantItem>
  );
};

export default SwatchSelect;
